import { getFunctions, httpsCallable } from '@firebase/functions';
import { app } from '@/src/features/services/firebase/client/app';
import { UserSubscriptionResponse } from '@/features/subscription/interfaces/SubscriptionTypes';

const functions = getFunctions(app);

// Note: UID is automatically determined by Firebase
const callFunction = async <T = unknown>(
  name: string,
  data?: unknown,
): Promise<T> => {
  const result = await httpsCallable(functions, name)(data);
  return result.data as T;
};

export const handleUserDataMigration = () =>
  callFunction('handleUserDataMigrationRTDBToFireStore');

export const createAuthCustomToken = () =>
  callFunction('createAuthCustomToken');

export const callDeleteUserAccount = () => callFunction('removeUserGen2');

export const fetchLeaderBoardFn = (payload: {
  targetLanguage: string;
  uid: string;
}) => callFunction('fetchLeaderBoard', payload);

export const updateLeaderBoardFn = (payload: {
  targetLanguage: string;
  userName: string;
  bananas: { daily: number; allTime: number };
  photoURL: string;
  uid: string;
}) => callFunction('updateLeaderBoard', payload);

export const getUserSubscription = () =>
  callFunction<UserSubscriptionResponse>('getUserSubscriptionV2', {
    platform: 'web',
  });
